[
  {
    "id": "vfx-default-texture",
    "package": "vfx",
    "src": "default_texture.png"
  },
  {
    "id": "aqua-noise",
    "package": "render2d",
    "src": "textures/noise-granulation.png"
  }
]
